function carouselRender() {
  // 1. Query the DOM inside the function so it grabs fresh elements after Editor changes
  const swiperBlocks = document.querySelectorAll('.swiper');

  swiperBlocks.forEach(block => {
    // 2. Destroy the existing Swiper instance if it already exists
    if (block.swiper !== undefined) {
      block.swiper.destroy(true, true);
    }

    // Safely grab attributes (getAttribute is much safer than block.attributes.value)
    let swiperSlides = parseInt(block.getAttribute('slides'));
    let space = parseInt(block.getAttribute('space'));
    let mobSpace = block.hasAttribute('mobileSpace') ? parseInt(block.getAttribute('mobileSpace')) : space;

    let id = block.getAttribute('id');
    let tabAttr = block.getAttribute('tabslides');
    let tabSlides = tabAttr ? parseInt(tabAttr) : 2;

    let next = '.swiper-next-' + id;
    let prev = '.swiper-prev-' + id;

    // 3. Initialize directly on the 'block' DOM node rather than constructing a namespace string
    const swiper = new Swiper(block, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: mobSpace,
      centeredSlides: true,
      grabCursor: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preloadImages: true,
      updateOnImagesReady: true,
      breakpoints: {
        576: {
          slidesPerView: tabSlides,
          spaceBetween: space,
          centeredSlides: false,
        },
        767: {
          slidesPerView: swiperSlides,
          spaceBetween: space,
          centeredSlides: false,
        },
      },
      pagination: {
        // Scoped to the current block so multiple carousels don't conflict
        el: block.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      scrollbar: {
        // Scoped to the current block
        el: block.querySelector('.swiper-scrollbar'),
      },
    });
  });
}

// Fire on initial load
document.addEventListener('DOMContentLoaded', carouselRender);
// Fire when Shopify Theme Editor re-renders a section
document.addEventListener("shopify:section:load", carouselRender);